import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/offer";
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const check = () => {
      const anchor = document.getElementById("hero-cta");
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener("scroll", check, {
      passive: true
    });
    window.addEventListener("resize", check);
    return () => {
      window.removeEventListener("scroll", check);
      window.removeEventListener("resize", check);
    };
  }, []);
  return <AnimatePresence data-id="element-149" data-mp="2av1tc76drn2s">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 24
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-3 bottom-3 z-40 md:inset-x-auto md:bottom-6 md:right-6" data-id="element-150" data-mp="38ayz6oxtmpld">
          <a href={CHECKOUT_URL} onClick={() => window.fbq?.("track", "InitiateCheckout")} className="animate-cta-shake flex w-full items-center justify-center gap-2 rounded-2xl bg-gold-400 px-5 py-4 text-base font-extrabold uppercase tracking-tight text-brand-950 shadow-[0_6px_0_0_#D99A00,0_16px_36px_-8px_rgba(0,0,0,0.45)] ring-2 ring-white focus:outline-none focus-visible:ring-4 focus-visible:ring-gold-200 md:px-7" data-id="element-151" data-mp="3342krrsm9i2k">
            <span className="whitespace-nowrap" data-id="element-152" data-mp="2kaoxm8v5afxi">Get instant access · $27</span>
            <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-153" data-mp="26f4qeaos3m5x" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}